import { render, staticRenderFns } from "./irankish.vue?vue&type=template&id=1bab03de"
import script from "./irankish.vue?vue&type=script&lang=js"
export * from "./irankish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports